<template>
  <section>
    <search-product />
    <pagination :pagination="_pagination" @pageClick="getProducts"/>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <brands />
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <categories />
      </b-col>
    </b-row>
    <list-product />
    <pagination :pagination="_pagination" @pageClick="getProducts"/>
  </section>
</template>

<script>
import SearchProduct from './SearchProduct.vue'
import ListProduct from './ListProduct.vue'
import Brands from './Brands.vue'
import Categories from './Categories.vue'
import Pagination from '@/components/Pagination.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'SearchProductHome',
  components: {
    SearchProduct,
    Brands,
    Categories,
    ListProduct,
    Pagination,
  },
  computed: {
    ...mapGetters('tySearchProduct', ['_pagination', '_searchKey', '_checkedBarcodes']),
  },
  methods: {
    getProducts(page) {
      console.log('Page clicked:', page)
      this.$store.commit('tySearchProduct/setPagination', { ...this._pagination, current_page: page })
      this.$store.dispatch('tySearchProduct/setSearchFormBy', this._searchKey)
    },
  },
  created() {
    // this.$store.dispatch('store/stores')
  },
}
</script>
